<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "views-administrator-backoffice-affiliates",
  mounted() {
    if (
      this.$route.name == "AdministratorAffiliates"
      || this.$route.name == "AdministratorAffiliatesReports"
    ) {
      this.$router
        .push({
          name: "AdministratorOnlineExtract",
        })
        .catch(() => {});
    } else if (
      this.$route.name ==
      "AdministratorOnlineAffiliatesUsersAffiliatesAnalyticalReport"
    ) {
      this.$store.commit("showDialog", true);
    }
  },
  watch: {
    $route(val) {
      if (
        val.name == "AdministratorAffiliates"
        || val.name == "AdministratorAffiliatesReports"
      ) {
        this.$router
          .push({
            name: "AdministratorOnlineExtract",
          })
          .catch(() => {});
      }
    },
  },
};
</script>
